import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7417c6ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "copy-right" }
const _hoisted_2 = ["href"]


export default /*#__PURE__*/_defineComponent({
  __name: 'CopyRight',
  setup(__props) {

const ICP_NO = process.env.VUE_APP_ICP_NO;
const DOMAIN_INDEX = process.env.VUE_APP_ICP_INDEX;
const BEIAN_WEBSITE = process.env.VUE_APP_BEIAN_WEBSITE;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, [
      _createElementVNode("a", {
        href: _unref(BEIAN_WEBSITE),
        target: "_blank"
      }, _toDisplayString(_unref(ICP_NO)) + "-" + _toDisplayString(_unref(DOMAIN_INDEX)), 9, _hoisted_2)
    ])
  ]))
}
}

})